import {
  getTrendGraphDateFormat,
  groupBy,
} from "../../../../utility/common-methods.jsx";
import {
  getLineGraphFormat,
  getRandomUniqueColor,
} from "../../../Dashboard/data_formatter/format-utils";
import {
  CONSTANTS,
  GRAPH_TYPES,
  REPORT_TYPES,
} from "../../../../constants/app-constant";
import { SOCIAL_SOURCES_OPTIONS } from "../../../../constants/static-filter.jsx";
const { AREA } = GRAPH_TYPES;
const { TONALITY } = CONSTANTS;
const { PLATFORM_RANK, ShareRetweet, PLATFORM_TONALITY, PLATFORM_TREND, ReplyComment , Attachment , Like , AuthorLike , MemberType , TypeOfPost , AuthorCreated } = REPORT_TYPES;

export const formatDataByPlatform = (
  d = [],
  graph_type,
  isLineGraph,
  report_type,
  selectedInlinePlatform
) => {
  try {
    const listOfPlatforms = SOCIAL_SOURCES_OPTIONS;
    const { graph_data } = d || {};
    let listOfTopics = graph_data.map((topic) => topic.topic_name);
    listOfTopics = isLineGraph
      ? getLineGraphFormat(listOfTopics, true)
      : listOfTopics;
    if (report_type == PLATFORM_RANK) {
      let labels = listOfPlatforms.map((ss) => ss.label);
      labels = isLineGraph ? getLineGraphFormat(labels, true) : labels;
      const graphColors = getRandomUniqueColor(labels.length);
      const datasets = graph_data.map((topic, index) => {
        const { post_count } = topic;
        let tempData = listOfPlatforms.map((sso) => {
          const pc = post_count.filter((elm) => elm.channel_type == sso.id);
          return (pc && pc[0] && pc[0].count) || 0;
        });
        tempData = isLineGraph ? getLineGraphFormat(tempData) : tempData;
        return {
          label: topic.topic_name,
          data: tempData,
          backgroundColor:
            graph_type === AREA && typeof window.Color === "function"
              ? window.Color(graphColors[index]).alpha(0.5).rgbString()
              : graphColors[index],
          borderColor: graphColors[index],
          borderWidth: 1,
          fill: graph_type === AREA ? "start" : false,
          lineTension: 0,
        };
      });
      return {
        datasets,
        labels,
      };
    }
    if (report_type == ShareRetweet) {
      let labels = listOfPlatforms.filter((data) => data.showInShareRetweet).map((ss) => ss.label);
      if(selectedInlinePlatform){
        labels = labels.filter((data) => data === selectedInlinePlatform.label)
      }
      labels = isLineGraph ? getLineGraphFormat(labels, true) : labels;
      const graphColors = getRandomUniqueColor(labels.length);
      const datasets = graph_data.map((topic, index) => {
        const { post_data } = topic;
        let tempData = listOfPlatforms.filter((data) => data.showInShareRetweet &&  (selectedInlinePlatform === null || selectedInlinePlatform === undefined || (selectedInlinePlatform !== null && selectedInlinePlatform !== undefined && data.value === selectedInlinePlatform.value))).map((sso) => {
          const pc = post_data.filter((elm) => elm.channel_type == sso.id);
          return (pc && pc[0] && pc[0].share_count) || 0;
        });
        tempData = isLineGraph ? getLineGraphFormat(tempData) : tempData;
        return {
          label: topic.topic_name,
          data: tempData,
          backgroundColor:
            graph_type === AREA && typeof window.Color === "function"
              ? window.Color(graphColors[index]).alpha(0.5).rgbString()
              : graphColors[index],
          borderColor: graphColors[index],
          borderWidth: 1,
          fill: graph_type === AREA ? "start" : false,
          lineTension: 0,
        };
      });
      return {
        datasets,
        labels,
      };
    }
    if (report_type == ReplyComment) {
      let labels = listOfPlatforms.filter((data) => data.showInReplyComment).map((ss) => ss.label);
      if(selectedInlinePlatform){
        labels = labels.filter((data) => data === selectedInlinePlatform.label)
      }
      labels = isLineGraph ? getLineGraphFormat(labels, true) : labels;
      const graphColors = getRandomUniqueColor(labels.length);
      const datasets = graph_data.map((topic, index) => {
        const { post_data } = topic;
        let tempData = listOfPlatforms.filter((data) => data.showInReplyComment &&  (selectedInlinePlatform === null || selectedInlinePlatform === undefined || (selectedInlinePlatform !== null && selectedInlinePlatform !== undefined && data.value === selectedInlinePlatform.value))).map((sso) => {
          const pc = post_data.filter((elm) => elm.channel_type == sso.id);
          return (pc && pc[0] && pc[0].comment_count) || 0;
        });
        tempData = isLineGraph ? getLineGraphFormat(tempData) : tempData;
        return {
          label: topic.topic_name,
          data: tempData,
          backgroundColor:
            graph_type === AREA && typeof window.Color === "function"
              ? window.Color(graphColors[index]).alpha(0.5).rgbString()
              : graphColors[index],
          borderColor: graphColors[index],
          borderWidth: 1,
          fill: graph_type === AREA ? "start" : false,
          lineTension: 0,
        };
      });
      return {
        datasets,
        labels,
      };
    }
    if (report_type == Attachment) {
      let labels = listOfPlatforms.filter((data) => data.showInAttachment &&  (selectedInlinePlatform === null || selectedInlinePlatform === undefined || (selectedInlinePlatform !== null && selectedInlinePlatform !== undefined && data.value === selectedInlinePlatform.value))).map((ss) => ss.label);
      // if(selectedInlinePlatform){
      //   labels = labels.filter((data) => data === selectedInlinePlatform.label)
      // }
      labels = isLineGraph ? getLineGraphFormat(labels, true) : labels;
      const graphColors = getRandomUniqueColor(labels.length);
      const datasets = graph_data.map((topic, index) => {
        const { post_data } = topic;
        let tempData = listOfPlatforms.filter((data) => data.showInAttachment &&  (selectedInlinePlatform === null || selectedInlinePlatform === undefined || (selectedInlinePlatform !== null && selectedInlinePlatform !== undefined && data.value === selectedInlinePlatform.value))).map((sso) => {
          const pc = post_data.filter((elm) => elm.channel_type == sso.id);
          return (pc && pc[0] && pc[0].count) || 0;
        });
        tempData = isLineGraph ? getLineGraphFormat(tempData) : tempData;
        return {
          label: topic.topic_name,
          data: tempData,
          backgroundColor:
            graph_type === AREA && typeof window.Color === "function"
              ? window.Color(graphColors[index]).alpha(0.5).rgbString()
              : graphColors[index],
          borderColor: graphColors[index],
          borderWidth: 1,
          fill: graph_type === AREA ? "start" : false,
          lineTension: 0,
        };
      });
      return {
        datasets,
        labels,
      };
    }
    if (report_type == Like) {
      let labels = listOfPlatforms.filter((data) => data.showInReplyComment &&  (selectedInlinePlatform === null || selectedInlinePlatform === undefined || (selectedInlinePlatform !== null && selectedInlinePlatform !== undefined && data.value === selectedInlinePlatform.value))).map((ss) => ss.label);
      labels = isLineGraph ? getLineGraphFormat(labels, true) : labels;
      const graphColors = getRandomUniqueColor(labels.length);
      const datasets = graph_data.map((topic, index) => {
        const { post_data } = topic;
        let tempData = listOfPlatforms.filter((data) => data.showInReplyComment &&  (selectedInlinePlatform === null || selectedInlinePlatform === undefined || (selectedInlinePlatform !== null && selectedInlinePlatform !== undefined && data.value === selectedInlinePlatform.value))).map((sso) => {
          const pc = post_data.filter((elm) => elm.channel_type == sso.id);
          return (pc && pc[0] && pc[0].like_count) || 0;
        });
        tempData = isLineGraph ? getLineGraphFormat(tempData) : tempData;
        return {
          label: topic.topic_name,
          data: tempData,
          backgroundColor:
            graph_type === AREA && typeof window.Color === "function"
              ? window.Color(graphColors[index]).alpha(0.5).rgbString()
              : graphColors[index],
          borderColor: graphColors[index],
          borderWidth: 1,
          fill: graph_type === AREA ? "start" : false,
          lineTension: 0,
        };
      });
      return {
        datasets,
        labels,
      };
    }
    if (report_type == AuthorLike) {
      let labels = listOfPlatforms.map((ss) => ss.label);
      labels = isLineGraph ? getLineGraphFormat(labels, true) : labels;
      const graphColors = getRandomUniqueColor(labels.length);
      const datasets = graph_data.map((topic, index) => {
        const { post_data } = topic;
        let tempData = listOfPlatforms.map((sso) => {
          const pc = post_data.filter((elm) => elm.channel_type == sso.id);
          return (pc && pc[0] && pc[0].likes_count) || 0;
        });
        tempData = isLineGraph ? getLineGraphFormat(tempData) : tempData;
        return {
          label: topic.topic_name,
          data: tempData,
          backgroundColor:
            graph_type === AREA && typeof window.Color === "function"
              ? window.Color(graphColors[index]).alpha(0.5).rgbString()
              : graphColors[index],
          borderColor: graphColors[index],
          borderWidth: 1,
          fill: graph_type === AREA ? "start" : false,
          lineTension: 0,
        };
      });
      return {
        datasets,
        labels,
      };
    }
    if (report_type == MemberType) {
      let labels = listOfPlatforms.filter((data) => data.showInMemberType &&  (selectedInlinePlatform === null || selectedInlinePlatform === undefined || (selectedInlinePlatform !== null && selectedInlinePlatform !== undefined && data.value === selectedInlinePlatform.value))).map((ss) => ss.label);
      labels = isLineGraph ? getLineGraphFormat(labels, true) : labels;
      const graphColors = getRandomUniqueColor(labels.length);
      const datasets = graph_data.map((topic, index) => {
        const { post_data } = topic;
        let tempData = listOfPlatforms.filter((data) => data.showInMemberType &&  (selectedInlinePlatform === null || selectedInlinePlatform === undefined || (selectedInlinePlatform !== null && selectedInlinePlatform !== undefined && data.value === selectedInlinePlatform.value))).map((sso) => {
          const pc = post_data.filter((elm) => elm.channel_type == sso.id);
          return (pc && pc[0] && pc[0].count) || 0;
        });
        tempData = isLineGraph ? getLineGraphFormat(tempData) : tempData;
        return {
          label: topic.topic_name,
          data: tempData,
          backgroundColor:
            graph_type === AREA && typeof window.Color === "function"
              ? window.Color(graphColors[index]).alpha(0.5).rgbString()
              : graphColors[index],
          borderColor: graphColors[index],
          borderWidth: 1,
          fill: graph_type === AREA ? "start" : false,
          lineTension: 0,
        };
      });
      return {
        datasets,
        labels,
      };
    }
    if (report_type == AuthorCreated) {
      let labels = listOfPlatforms.map((ss) => ss.label);
      labels = isLineGraph ? getLineGraphFormat(labels, true) : labels;
      const graphColors = getRandomUniqueColor(labels.length);
      const datasets = graph_data.map((topic, index) => {
        const { post_data } = topic;
        let tempData = listOfPlatforms.map((sso) => {
          const pc = post_data.filter((elm) => elm.channel_type == sso.id);
          return (pc && pc[0] && pc[0].count) || 0;
        });
        tempData = isLineGraph ? getLineGraphFormat(tempData) : tempData;
        return {
          label: topic.topic_name,
          data: tempData,
          backgroundColor:
            graph_type === AREA && typeof window.Color === "function"
              ? window.Color(graphColors[index]).alpha(0.5).rgbString()
              : graphColors[index],
          borderColor: graphColors[index],
          borderWidth: 1,
          fill: graph_type === AREA ? "start" : false,
          lineTension: 0,
        };
      });
      return {
        datasets,
        labels,
      };
    }
    if (report_type == TypeOfPost) {
      let labels = listOfPlatforms.filter((data) => data.showInTypePost &&  (selectedInlinePlatform === null || selectedInlinePlatform === undefined || (selectedInlinePlatform !== null && selectedInlinePlatform !== undefined && data.value === selectedInlinePlatform.value))).map((ss) => ss.label);

      labels = isLineGraph ? getLineGraphFormat(labels, true) : labels;
      const graphColors = getRandomUniqueColor(labels.length);
      const datasets = graph_data.map((topic, index) => {
        const { post_data } = topic;
        let tempData = listOfPlatforms.filter((data) => data.showInTypePost &&  (selectedInlinePlatform === null || selectedInlinePlatform === undefined || (selectedInlinePlatform !== null && selectedInlinePlatform !== undefined && data.value === selectedInlinePlatform.value))).map((sso) => {
          const pc = post_data.filter((elm) => elm.channel_type == sso.id);
          return (pc && pc[0] && pc[0].count) || 0;
        });
        tempData = isLineGraph ? getLineGraphFormat(tempData) : tempData;
        return {
          label: topic.topic_name,
          data: tempData,
          backgroundColor:
            graph_type === AREA && typeof window.Color === "function"
              ? window.Color(graphColors[index]).alpha(0.5).rgbString()
              : graphColors[index],
          borderColor: graphColors[index],
          borderWidth: 1,
          fill: graph_type === AREA ? "start" : false,
          lineTension: 0,
        };
      });
      return {
        datasets,
        labels,
      };
    }
    if (report_type == PLATFORM_TONALITY) {
      const datasets = TONALITY.map((sentiment, index) => {
        const { label, color } = sentiment;

        let tempData = graph_data.map((topic) => {
          const { post_count } = topic;
          const groupedDataBySentiment = groupBy(post_count, "tonality");
          let [tempCount, currentSentimentData] = [
            0,
            groupedDataBySentiment[label] || [],
          ];
          currentSentimentData.forEach(({ count }) => {
            tempCount += parseInt(count, 10);
          });
          return tempCount;
        });
        tempData = isLineGraph ? getLineGraphFormat(tempData) : tempData;
        return {
          label,
          data: tempData,
          backgroundColor:
            graph_type === AREA && typeof window.Color === "function"
              ? window.Color(color).alpha(0.5).rgbString()
              : color,
          borderColor: color,
          borderWidth: 1,
          fill: graph_type === AREA ? "start" : false,
          lineTension: 0,
        };
      });
      return {
        datasets,
        labels: listOfTopics,
      };
    }
    if (report_type == PLATFORM_TREND) {
      function reducerFn(total, num) {
        return total + num;
      }
      const formattedData = [];
      let listOfDates = graph_data.map((gd) => {
        const { post_count } = gd;
        const tempList = post_count.map((pc) => pc.data.flat()).flat();
        formattedData.push({
          topic_name: gd.topic_name,
          data: groupBy(tempList, "created_at"),
        });
        return tempList.flat();
      });
      listOfDates = Object.keys(groupBy(listOfDates.flat(), "created_at"));
      const graphColors = getRandomUniqueColor(listOfDates.length);
      let labels = listOfDates.map((d) => getTrendGraphDateFormat(d));
      let datasets = formattedData.map((fData, index) => {
        const { topic_name, data } = fData;
        const tempData = Object.keys(data).map((elm) => {
          const currentData = data[elm].map((el) => parseInt(el.count, 10));
          const currentDataSum = currentData.reduce(reducerFn);
          return currentDataSum;
        });
        return {
          label: topic_name,
          data: isLineGraph ? getLineGraphFormat(tempData) : tempData,
          backgroundColor:
            graph_type === AREA && typeof window.Color === "function"
              ? window.Color(graphColors[index]).alpha(0.5).rgbString()
              : graphColors[index],
          borderColor: graphColors[index],
          borderWidth: 1,
          fill: graph_type === AREA ? "start" : false,
          lineTension: 0,
        };
      });
      labels = isLineGraph ? getLineGraphFormat(labels, true) : labels;
      return {
        datasets,
        labels,
      };
    }
  } catch (e) {
    console.log(e);
    return {
      datasets: [],
      labels: [],
    };
  }
};
